module.exports = __webpack_public_path__ + "img/client_logo.3e1c2d76.webp";